'use client';

import type { JSX } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { HeaderContainer, renderHeaderMobileVariation } from '@/components';

/**
 * Props for `HeaderMobile`.
 */
export type HeaderMobileProps = SliceComponentProps<Content.HeaderMobileSlice>;

/**
 * Component for "HeaderMobile" Slices (Slice Machine simulator).
 */
const HeaderMobile = ({ slice }: HeaderMobileProps): JSX.Element => (
  <HeaderContainer
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
  >
    <HeaderContainer.Mobile>
      {renderHeaderMobileVariation(slice.variation)}
    </HeaderContainer.Mobile>
  </HeaderContainer>
);

export default HeaderMobile;
